import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_PARTNER_GET_BY_USER_ID,
} from 'api/actionTypes';

export default async function getByUserId({ state, apiClient }, { userId, forceRefresh = false }) {
  typeCheck('userId::PositiveNumber', userId);

  const statePath = ['partners', 'byUserId', userId];
  if (state.get(statePath) && !forceRefresh) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_BY_USER_ID,
    queryId: String(userId),
    state: state,
    payload: {
      userId: userId,
    },
    onSuccess(partner) {
      state.set(statePath, partner);
    },
  });
}
